<template>
    <section class="search-home">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-lg-7">
                    <Search />
                </div>
            </div>

            <ResultStores />
        </div>
    </section>
</template>

<script>
    import Search from "@/components/Essentials/Search.vue"
    import ResultStores from "@/components/Home/ResultStores.vue"
    
    import getMyContentLanguage from "@/services/contentLanguage.js"

    export default {
        components: {
            Search,
            ResultStores
        },
        
        data(){
            return {
                flagSelected: "en",
            }
        },

        methods: {
            languageSelected(){
                this.flagSelected = this.$store.state.SelectLanguage.code
            },

            getMyLanguage(group, code) {
                return getMyContentLanguage(group, code, this.$store.state.SelectLanguage.code)
            },
        },

        watch: {
            '$store.state.SelectLanguage.code': {
                immediate: true,
                handler() {
                    this.languageSelected();
                }
            }
        }
    }
</script>


<style lang="scss" scoped>
    @import '@/assets/scss/_dneElements.scss';
    @import '@/assets/scss/_colors.scss';

    body.body-select-region .search-home{
        z-index: 9999;
    }

    .search-home{
        @include paddingSection;
        background: #eee;
        
        .row{
            justify-content: center;
            align-items: center;
        }
        
        .container-fluid{
            position: relative;
            z-index: 20;
            width: 100%;
            max-width: 1400px;
            
            @media (min-width: 992px){
                padding: 0 50px;
            }

            h3{
                color: $color-text-tertiary;
                margin-bottom: 20px;
                position: relative;
                z-index: 20;
                text-shadow: 0px 4px 6px rgba(0,0,0,0.3);
                
                @media (max-width: 992px){
                    font-size: 34px;
                    line-height: 36px;
                    text-align: center;
                }
                
                @media (min-width: 576px) and (max-width: 1200px){
                    font-size: 50px;
                    line-height: 52px;
                }

                @media (min-width: 1200px){
                    font-size: 60px;
                    line-height: 62px;
                }
            }

            p{
                color: $color-text-tertiary;
                position: relative;
                z-index: 20;
                text-shadow: 0px 4px 6px rgba(0,0,0,0.3);
                
                @media (max-width: 992px){
                    font-size: 14px;
                    line-height: 18px;
                    text-align: center;
                    margin-bottom: 30px;
                }
                
                @media (min-width: 992px){
                    font-size: 18px;
                    line-height: 22px;
                    margin-bottom: 50px;
                }
            }

            .col-img{
                display: flex;

                @media (max-width: 992px){
                    display: none;
                }

                @media (min-width: 992px) and (max-width: 1200px){
                    justify-content: flex-end;
                    height: 320px;
                }
                
                @media (min-width: 1200px){
                    justify-content: flex-end;
                    height: 360px;
                }

                img{
                    width: auto;
                    max-width: none;
                    height: 100%;
                }
            }
        }
    }
</style>